// Preserve the scheduling API used by legacy form callbacks. Browsers do not
// provide setImmediate natively, so keep the behavior explicit.
if (typeof window.setImmediate !== "function") {
  window.setImmediate = (callback, ...args) => window.setTimeout(callback, 0, ...args);
}
